<div class="modal-header">
  <div class="grow">
    <h4 class="modal-title">{{ 'ACCESS_KEY.TITLE' | translate }}</h4>
     <p class="modal-para">{{ 'ACCESS_KEY.SUBTITLE' | translate }}</p>
     </div>
   <button type="button" class="modal-close" aria-label="Close" (click)="close()" data-testid="access-key-close-btn">
      <img src="assets/img/shared/modal-close.svg" alt="">
    </button>
</div>

<div class="modal-body">
  @if (loading() && data()?.accessKey?.accessKey === null) {
  <div class="access-key-skeleton skeleton-card" aria-hidden="true">
    <div class="skeleton-line" style="width:60%;height:20px;margin:8px auto;"></div>
    <div class="skeleton-line" style="width:40%;height:14px;margin:8px auto;"></div>
    <div class="skeleton-line" style="width:80%;height:12px;margin:12px auto;"></div>
  </div>
  } @else {
  @if (data()?.accessKey?.accessKey === null) {
   <div class="no-data-found ">
    <p class="mb-3 ">{{ 'ACCESS_KEY.NO_KEYS_FOUND' | translate }}</p>
  </div>
  } @else {
  <div class="access-key-card">
    <div class="key-value-section">
      <h6 > API Key </h6>
      <div class="key-value-display">
        <code class="key-value">{{ data()?.accessKey?.accessKey }}</code>
        <button type="button" class="tooltip-item copy-key-btn"
          (click)="copyWithTooltip(data()?.accessKey?.accessKey, keyTooltip)"
          [disabled]="keyCopied" [ngbTooltip]="keyCopied ? ('CREATE_USER.PASSWORD_COPIED' | translate) : ('COMMON.COPY' | translate)" #keyTooltip="ngbTooltip" placement="top"
          triggers="mouseenter:mouseleave" aria-label="Copy API key"
          data-testid="access-key-copy-btn">
          <img [src]="keyCopied ? 'assets/img/userManagement/success.svg' : 'assets/img/shared/copy.svg'"
            alt="copy" />
        </button>
      </div>
    </div>
    <div class="key-meta">
      <span class="active">{{ 'ACCESS_KEY.STATUS_ACTIVE' | translate }}</span>      
        <span class="meta-text">{{ 'ACCESS_KEY.COL_CREATED' | translate }}: {{  data()?.accessKey?.modifiedDate === null ? ( data()?.accessKey?.createdDate | date: 'MMM d, yyyy') :  (data()?.accessKey?.modifiedDate | date: 'MMM d, yyyy')  }}</span>
    </div>   
  </div>
  }
  }
</div>

 <div class="modal-footer">
    <button type="button" class="lite-btn" (click)="close()" data-testid="access-key-cancel-btn">
      {{ 'COMMON.CANCEL' | translate }}
    </button>    
@if( data()?.accessKey?.accessKey === null)
{
  <div class="d-flex justify-content-center">
   <button type="button" class="primary-btn" (click)="generateKey()" data-testid="access-key-generate-btn">
     + {{ 'ACCESS_KEY.GENERATE_KEY' | translate }}
   </button>
 </div>
}
@else {
        <button type="button" class="primary-btn" (click)="generateKey()" data-testid="access-key-regenerate-btn">
          @if(loading() && data()?.accessKey?.accessKey !== null)
          {
  
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
             Regenerating...
          }
          @else{
                     <img src="assets/img/Settings/regenerate.svg" alt="regenerate">   
                       Regenerate Key
          }
       
        </button>  
      }  
  </div>
